import React, {
  memo, useEffect, useMemo, useState,
} from 'react'
import Box from '@mui/material/Box'
import Page from 'components/layout/Page'
import { useRouter } from 'next/router'
import sx from './styles'

const ChallengeApp = () => {
  const [isClient, setIsClient] = useState(false)
  const [isInfluencerByUrl, setIsInfluencerByUrl] = useState(false)
  const router = useRouter()

  const urlIframe = useMemo(
    () => (isClient && isInfluencerByUrl
      ? 'https://app3.salesmanago.pl/mscf/ytlr078t9lrixtc3/default/ClikAuto_Prueba_simple.htm'
      : 'https://app3.salesmanago.pl/mscf/ytlr078t9lrixtc3/default/ClikAuto_Prueba.htm'),
    [isClient, isInfluencerByUrl],
  )

  useEffect(() => {
    setIsClient(true) // Solo se renderiza en el cliente
  }, [])

  useEffect(() => {
    if (router?.query) {
      setIsInfluencerByUrl(Boolean(router?.query?.utm_campaign))
    }
  }, [router?.query])

  return (
    <Page>
      {isClient ? (
        <Box sx={sx.root}>
          <iframe
            src={urlIframe}
            style={{ border: 'none' }}
            title="Iframe Example"
            allowFullScreen
          />
        </Box>
      ) : (
        <Box sx={sx.loading}>
          Loading
        </Box>
      )}

    </Page>
  )
}

export default memo(ChallengeApp)
